import React from "react";
import ScrollAnimation from "react-animate-on-scroll";

export default function AllProdi({ data }) {
  return (
    <div className="w-full mt-32">
      {data.map((prodi, i) => (
        <section
          key={i}
          id={`prodi${i}`}
          className="w-full md:py-40 -md:py-10 md:px-20 flex justify-center flex-col"
        >
          <div className="md:container flex -md:flex-col-reverse md:justify-between md:items-center">
            <div className="-md:container md:w-1/2 md:flex justify-start flex-col">
              <ScrollAnimation
                className="space-y-6"
                key={i}
                animateIn="fadeInLeft"
                animateOnce={true}
              >
                <h1
                  className="md:text-6xl -md:text-2xl text-yellow italic font-black"
                  dangerouslySetInnerHTML={{
                    __html: prodi.title,
                  }}
                />
                <div
                  className="bg-purple -md:hidden"
                  style={{ width: "260px", height: "16px" }}
                ></div>
              </ScrollAnimation>
            </div>
            <ScrollAnimation
              animateOnce={true}
              className="md:w-1/2 overflow-x-hidden md:absolute right-0 -md:h-72 -md:relative"
              key={i}
              animateIn="fadeInRight"
            >
              <img
                src={prodi.image}
                className="-md:absolute -md:w-10/12 -md:right-0"
                alt="Prodi"
              />
            </ScrollAnimation>
          </div>
          <div className="md:mt-52 -md:mt-5 container flex flex-col">
            {prodi.items.map((item, i) => (
              <ScrollAnimation
                animateOnce={true}
                key={i}
                animateIn="fadeInLeft"
              >
                <div className="flex justify-center md:items-center -md:py-5">
                  <div className="w-3/12">
                    <img src={item.image} alt="icon" />
                  </div>
                  <div className="w-9/12 flex flex-col">
                    <h2 className="text-4xl -md:text-sm font-extrabold text-purple">
                      {item.title}
                    </h2>
                    <ul className="pl-5 mt-2 list-disc list-outside space-y-2">
                      {item.items.map((list, i) => (
                        <li
                          key={i}
                          className="text-2xl -md:text-xs font-medium"
                        >
                          <span
                            className="md:flex md:space-x-2"
                            dangerouslySetInnerHTML={{
                              __html: list,
                            }}
                          />
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </ScrollAnimation>
            ))}
          </div>
        </section>
      ))}
    </div>
  );
}
